// Brace-depth helpers for fail-soft syntax recovery.
// Example: estimate how many `}` tokens need to be appended.
// Estimate missing closing-brace count while ignoring comments and strings.
export function estimateMissingClosingBraces(source: string): number {
  let braceDepth = 0
  let quote: "'" | '"' | null = null
  let inLineComment = false
  let inBlockComment = false

  // Scan source once and count only structural braces.
  for (let index = 0; index < source.length; index += 1) {
    const char = source[index]
    const next = source[index + 1] ?? ''
    const previous = index > 0 ? source[index - 1] : ''

    // Check whether the scanner is inside a line comment.
    if (inLineComment) {
      // Check whether the current line comment just ended.
      if (char === '\n') {
        inLineComment = false
      } else {
        // Continue skipping line-comment content.
      }
      continue
    } else if (inBlockComment) {
      // Check whether the current block comment just ended.
      if (char === '*' && next === '/') {
        inBlockComment = false
        index += 1
      } else {
        // Continue skipping block-comment content.
      }
      continue
    } else {
      // Continue structural scanning outside comments.
    }

    // Check whether the scanner is inside a quoted string.
    if (quote) {
      // Check whether the current quoted string just ended.
      if (char === quote && previous !== '\\') {
        quote = null
      } else {
        // Continue skipping quoted content.
      }
      continue
    } else {
      // Continue scanning outside quoted content.
    }

    // Check whether a new comment starts at the current position.
    if (char === '/' && next === '*') {
      inBlockComment = true
      index += 1
      continue
    } else if (char === '/' && next === '/') {
      inLineComment = true
      index += 1
      continue
    } else {
      // Continue non-comment scanning.
    }

    // Check whether a new quoted string starts here.
    if (char === "'" || char === '"') {
      quote = char
      continue
    } else {
      // Continue brace counting outside strings.
    }

    // Check whether the current token changes brace depth.
    if (char === '{') {
      braceDepth += 1
    } else if (char === '}') {
      braceDepth = Math.max(0, braceDepth - 1)
    } else {
      // Keep brace depth unchanged for other characters.
    }
  }

  // Return the remaining positive brace depth.
  return braceDepth
}
